import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getEventsList } from "../../store/slices/eventSlice";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import EventCell from "./EventCell";
import EventSubscriberModel from "../models/EventSubscriberModel";
import EventNotificationModel from "../models/EventNotificationModel";
import ScheduleEventNotificationModel from "../models/ScheduleEventNotificationModel";

const Events = () => {
    const dispatch = useDispatch();
    const { isLoading, events, isModelOpen, isEventNotificationModelOpen, isScheduleEventNotificationModelOpen } = useSelector((state) => state.event);

    useEffect(() => {
        dispatch(getEventsList({ page: 1, limit: 5 }));
    }, [dispatch]);

     

    return (
        <div className="polls-box">

            <div className="scrollable-container position-relative" style={{ overflow: "hidden auto" }}>
                {events?.map((event, index) => (
                    <EventCell key={'scheduled_'+event.id || index} event={event}/>
                ))}

                {isLoading && (
                    <div className="d-flex justify-content-center align-items-center p-4">
                        <div className="spinner-border text-primary" style={{ width: "2rem", height: "2rem" }} role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )}
            </div>
            <EventSubscriberModel show={isModelOpen} />
            <EventNotificationModel show={isEventNotificationModelOpen} />
            
            <ScheduleEventNotificationModel show={isScheduleEventNotificationModelOpen} />
        </div>
    );
};

export default Events;
